import React, {useState, useEffect} from 'react'
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import CircleIcon from '@mui/icons-material/Circle';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import * as _rtc from "webrtc-test-suite";
import OneMBFile from '../images/1mb.jpg'
import GetLiveCallPath from './LiveCallPath';

export default function WebRTCTest({iceServers}) {
  const [running, setRunning] = useState(false)
  const [completedCountDevices, setCompletedCountDevices] = useState(false)
  const [canCountDevices, setCanCountDevices] = useState(false)
  const [audioDevices, setAudioDevices] = useState(0)
  const [videoDevices, setVideoDevices] = useState(0)
  const [completedCaptureMedia, setCompletedCaptureMedia] = useState(false)
  const [canCaptureMedia, setCanCaptureMedia] = useState(false)
  const [completedPeerConnection, setCompletedPeerConnection] = useState(false)
  const [canPeerConnection, setCanPeerConnection] = useState(false)
  const [shouldTestRelayPerformance, setShouldTestRelayPerformance] = useState(false)
  const [completedRelayPerformance, setCompletedRelayPerformance] = useState(false)
  const [relayPerformanceGood, setRelayPerformanceGood] = useState(false)
  const [completedGetConnectionSpeed, setCompletedGetConnectionSpeed] = useState(false)
  const [connectionSpeedGood, setConnectionSpeedGood] = useState(false)
  const [connectionSpeed, setConnectionSpeed] = useState(null)

//   useEffect(() => {
//     if (!iceServers) return
//     iceServers.forEach(server => {
//         if (server.hasOwnProperty('urls')) {
//             if (Array.isArray(server.urls)) {
//                 server.urls.forEach(url => {
//                     if (url.includes('turn:')) setShouldTestRelayPerformance(true)
//                 })
                
//             } else {
//                 if (server.urls.includes('turn:')) setShouldTestRelayPerformance(true)
//             }
//         }
//     })
//   }, [])

  useEffect(() => {
    if (!running) return
    _rtc.countDevies() //library has spelling error
    .then(result => {
        setCanCountDevices(true)
        setCompletedCountDevices(true)
        setAudioDevices(result.audio.in)
        setVideoDevices(result.video.in)
    })    
    .catch(()=>console.log("device count failed"));

    _rtc.checkMediaCapture({audio: true, video: true})
    .then(() => {
        setCanCaptureMedia(true)
        setCompletedCaptureMedia(true)
    })
    .catch(() => setCompletedCaptureMedia(true));

    let rtcConfig = {}
    if (iceServers) {
            rtcConfig['iceServers'] = iceServers
    }
    console.log('rtcConfig', rtcConfig)

    _rtc.checkPeerConnection(rtcConfig)
    .then(() => {
        setCanPeerConnection(true)
        setCompletedPeerConnection(true)
    })
    .catch(() => setCompletedPeerConnection(true));

    _rtc.checkInternetSpeed(GetLiveCallPath(OneMBFile))
    .then(speed => {
        setConnectionSpeed(speed)
        setCompletedGetConnectionSpeed(true)
        if (speed > 10) {
            setConnectionSpeedGood(true)
        }
    })
    .catch(() => {
        setCompletedGetConnectionSpeed(true)
    })

    if (shouldTestRelayPerformance) {
        if (iceServers) {
                rtcConfig['iceServers'] = iceServers
                rtcConfig['iceTransportPolicy'] = "relay"
        }

        _rtc.checkRelayPerformance(rtcConfig, [true, 30000])
        .then((result) => {
            console.log("Relay Performance", result)
            setCompletedRelayPerformance(true)
        })
        .catch((error) => {
            console.log("Relay Performance failed", error)
            setCompletedRelayPerformance(true)
        });
    }

  }, [running])


  const renderCircle = (capable, completed) => {
    let component= null
    if (!completed) {
        component = <CircleIcon/>
    } else if (completed && capable) {
        component = <CheckCircleIcon color='primary'/>
    } else {
        component = <ErrorIcon color='danger'/>
    }
    return component
  }

  return (
    <div className='live-call-webrtc-tests'>
        <h3>Compatability Tests</h3>
        <Stack spacing={2}>
            <div className='live-call-webrtc-test'>
                {renderCircle(canCountDevices, completedCountDevices)}
                {!completedCountDevices ? 
                    <>
                    Count Input Devices
                    </>
                :
                    <>
                    {canCountDevices ? 
                        `Inputs: ${audioDevices} Audio, ${videoDevices} Video` 
                    :
                        'Device Count Failed'
                    }
                    </>
                }
            </div>
            <div className='live-call-webrtc-test'>
                {renderCircle(canCaptureMedia, completedCaptureMedia)}
                {!completedCaptureMedia ? 
                    <>
                    Test Media Capture
                    </>
                :
                    <>
                    {canCaptureMedia ? 
                        'Media Capture Successful'
                    :
                        'Media Capture Failed'
                    }
                    </>
                }
            </div>
            <div className='live-call-webrtc-test'>
                {renderCircle(canPeerConnection, completedPeerConnection)}
                {!completedPeerConnection ? 
                    <>
                    Test Peer Connection
                    </>
                :
                    <>
                    {canPeerConnection ? 
                        'Peer Connection Established'
                    :
                        'Peer Connection Failed'
                    }
                    </>
                }
            </div>
            <div className='live-call-webrtc-test'>
                {renderCircle(connectionSpeedGood, completedGetConnectionSpeed)}
                {!completedGetConnectionSpeed ? 
                    <>
                    Test Connection Speed
                    </>
                :
                    <>
                    {connectionSpeedGood ? 
                        `Connection Speed ${connectionSpeed}Mb/s`
                    :
                        <>
                            {connectionSpeed ?
                                `Connection Speed ${connectionSpeed}Mb/s`
                            :
                                'Connection Speed Test Failed'
                            }
                        </>
                    }
                    </>
                }
            </div>
            {shouldTestRelayPerformance ? 
                <div className='live-call-webrtc-test'>
                    {renderCircle(relayPerformanceGood, completedRelayPerformance)}
                    {!completedRelayPerformance ? 
                        <>
                        Test Relay Performance
                        </>
                    :
                        <>
                        {relayPerformanceGood ? 
                            'Relay Performance Good'
                        :
                            'Relay Performance Poor'
                        }
                        </>
                    }
                </div>
            : 
                null
            }
            <Button 
                variant="contained"
                size="large"
                disabled={running}
                onClick={() => setRunning(true)}
                >
                    Run Tests
            </Button>
        </Stack>
    </div>
  )
}
